let api_token;

switch (window.Shopify.shop) {
  case "fostr-underscore.myshopify.com":
    api_token = "206fa93198662aeb44f1a671aa9f45f4"; // Dev Store
    break;
}

window.API_VERSION = "2023-10";
if (api_token) window.API_ACCESS = api_token;

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
class HTMLUpdateUtility {
  #preProcessCallbacks = [];
  #postProcessCallbacks = [];

  constructor() {}

  addPreProcessCallback(callback) {
    this.#preProcessCallbacks.push(callback);
  }

  addPostProcessCallback(callback) {
    this.#postProcessCallbacks.push(callback);
  }

  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  viewTransition(oldNode, newContent) {
    this.#preProcessCallbacks.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement("div");
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;
    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = "none";

    this.#postProcessCallbacks.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 1000);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", summary.parentNode.hasAttribute("open"));

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === "INPUT" && ["search", "text", "email", "url"].includes(elementToFocus.type) && elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) => button.addEventListener("click", this.onButtonClick.bind(this)));
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
    this.updateOherPageQtyInputs(event);
  }

  resetQuantityInputToOne() {
    this.input.value = 1;
    this.input.setAttribute("data-previous-value", "1");
    this.validateQtyRules();
    const buttonMinus = this.querySelector(".quantity__button[name='minus']");
    const buttonPlus = this.querySelector(".quantity__button[name='plus']");
    buttonMinus.classList.toggle("disabled", parseInt(this.input.value) <= parseInt(this.input.min || 0));
    buttonPlus.classList.toggle("disabled", parseInt(this.input.value) >= parseInt(this.input.max || Infinity));
  }

  updateOherPageQtyInputs(event) {
    // if closest element is 'cart-drawer-items' return
    if (event.target.closest("cart-drawer-items")) return;
    const previousValue = event.target.getAttribute("data-previous-value");
    if (previousValue === event.target.value) return;
    event.target.setAttribute("data-previous-value", event.target.value);
    const allQtyInputs = document.querySelectorAll(`quantity-input input[name="${event.target.name}"]`);
    allQtyInputs.forEach((input) => {
      if (input !== event.target) {
        input.value = event.target.value;
        const buttonMinus = input.closest("quantity-input").querySelector(".quantity__button[name='minus']");
        const buttonPlus = input.closest("quantity-input").querySelector(".quantity__button[name='plus']");
        buttonMinus.classList.toggle("disabled", parseInt(input.value) <= parseInt(input.min || 0));
        buttonPlus.classList.toggle("disabled", parseInt(input.value) >= parseInt(input.max || Infinity));
      }
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, false));
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (event.pointerType === "mouse" && !event.target.closest("deferred-media, product-model")) this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == "VIDEO" && deferredElement.getAttribute("autoplay")) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }

  playContent() {
    const media = this.querySelector("video, model-viewer");
    if (media) {
      if (media.nodeName == "VIDEO") {
        media.play();
      } else {
        media.modelViewerUI.play();
      }
    }
  }

  pauseContent() {
    const media = this.querySelector("video, model-viewer");
    if (media) {
      if (media.nodeName == "VIDEO") {
        media.pause();
      } else {
        media.modelViewerUI.pause();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.optionsSize = this.dataset.optionsSize || 0;
    this.hasBundleItems = this.querySelector("collapsible-content:first-of-type")?.dataset?.hasBundleItems === "true" || false;
    this.pdpDetailsSection = document.querySelector(".js-pdp-details-section")?.id || null;
    this.hasAccordions = !(this.dataset.noAccordions === "true");

    this.addEventListener("change", this.handleProductUpdate);
    this.initializeProductSwapUtility();
    this.initializeDetailsSwapUtility();

    if (this.optionsSize > 1 && this.hasAccordions) {
      this.attachActiveVariantEvent();
      this.closeAccordions();
    }
    if (this.hasBundleItems) {
      this.attachActiveVariantEvent();
    }

    this.handleVariantSelection();
    this.handleThirdPartyAppVariantSelection();
  }

  handleVariantSelection() {
    const variantSelector = document.querySelector('.variant-picker-container--single');
    if (!variantSelector) return;

    variantSelector.addEventListener('click', (event) => {
      const button = event.target.closest('.product-form__input > label');
      if (!button) return;
      const selectedOptionLabel = button.closest('variant-selects')?.querySelector('.js-selected-option-value');

      const value = button.querySelector('.js-option-value')?.dataset.value || button.querySelector('.swatch_name')?.dataset.value;

      if (!value || !selectedOptionLabel) return;

      selectedOptionLabel.textContent = value;
    });
  }

  handleThirdPartyAppVariantSelection() {
    const variantSelector = document.querySelector('.variant-picker-container--single');
    if (!variantSelector) return;

    function handleSelectedSize(ctmElement) {
      const updateStyle = () => {
        const variantOption = ctmElement.querySelector('.currently-selected-variant-option');
        if (!variantOption) return;

        const section = ctmElement.closest('variant-selects');
        if (!section) return;

        const span = Array.from(section.querySelectorAll('.label-text__name span'))
          .find(s => s.textContent.trim() === variantOption.textContent.trim());
        if (!span) return;

        let styleEl = document.getElementById('variant-after-style');
        if (!styleEl) {
          styleEl = document.createElement('style');
          styleEl.id = 'variant-after-style';
          document.head.appendChild(styleEl);
        }

        const appendText = span.dataset.value.replace(variantOption.textContent.trim(), '');

        styleEl.textContent = `
          .currently-selected-variant-option::after {
            content: "${appendText}";
          }
        `;
      };

      updateStyle();

      const variantOption = ctmElement.querySelector('.currently-selected-variant-option');
      if (variantOption) {
        const observer = new MutationObserver(updateStyle);
        observer.observe(variantOption, {
          characterData: true,
          subtree: true,
          childList: true
        });
      }
    }

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches('.ctm-selected-size')) {
            handleSelectedSize(node);
          } else {
            node.querySelectorAll('.ctm-selected-size').forEach(handleSelectedSize);
          }
        });
      });
    });

    observer.observe(variantSelector, { childList: true, subtree: true });
  }

  attachActiveVariantEvent() {
    const allSelectedLabels = this.querySelectorAll("input:checked + label, input.input-checked + label");
    allSelectedLabels.forEach((label) => {
      label.addEventListener("click", this.updateAccordionSelectedValueWhenActiveClicked.bind(this));
    });
  }

  refreshTrustPilotWidget() {
    const widgets = document.querySelectorAll(".trustpilot-widget");
    if (!widgets || widgets.length === 0) return;
    widgets.forEach((widget) => {
      Trustpilot.loadFromElement(widget);
    });
  }

  closeAccordions() {
    if (!this.hasAccordions) return;
    const allAccordions = this.querySelectorAll("collapsible-content > button.collapsible-content__header");
    if (!allAccordions) return;
    allAccordions.forEach((accordion) => {
      accordion.addEventListener("click", (e) => {
        // if element has atrtribute aria-expanded=true return
        if (e.currentTarget.getAttribute("aria-expanded") === "true") return;
        // close all other accordions
        allAccordions.forEach((accordion) => {
          if (accordion !== e.currentTarget) {
            accordion.parentNode.close();
          }
        });
      });
    });
  }

  initializeProductSwapUtility() {
    this.swapProductUtility = new HTMLUpdateUtility();
    this.swapProductUtility.addPreProcessCallback((html) => {
      html.querySelectorAll(".scroll-trigger").forEach((element) => element.classList.add("scroll-trigger--cancel"));
      return html;
    });
    this.swapProductUtility.addPostProcessCallback((newNode) => {
      window?.Shopify?.PaymentButton?.init();
      window?.ProductModel?.loadShopifyXR();
      publish(PUB_SUB_EVENTS.sectionRefreshed, {
        data: {
          sectionId: this.dataset.section,
          resource: {
            type: SECTION_REFRESH_RESOURCE_TYPE.product,
            id: newNode.querySelector("variant-selects").dataset.productId,
          },
        },
      });
    });
  }

  initializeDetailsSwapUtility() {
    this.detailsSwapUtility = new HTMLUpdateUtility();
    this.detailsSwapUtility.addPreProcessCallback((html) => {
      html.querySelectorAll(".scroll-trigger").forEach((element) => element.classList.add("scroll-trigger--cancel"));
      return html;
    });
    this.detailsSwapUtility.addPostProcessCallback((newNode) => {
      window?.Shopify?.PaymentButton?.init();
      window?.ProductModel?.loadShopifyXR();
      publish(PUB_SUB_EVENTS.sectionRefreshed, {
        data: {
          sectionId: this.pdpDetailsSection,
          resource: {
            type: SECTION_REFRESH_RESOURCE_TYPE.productDetails,
            id: newNode.querySelector(".js-pdp-details-section").dataset.productId,
          },
        },
      });
    });
  }

  updateSummaryBox(e) {
    const summaryBox = this.querySelector(".variant-selects__summary-box");
    if (!summaryBox) return;
    //check if event is click or change

    let optionName = null;
    let value = null;

    if (e.type === "click") {
      optionName = e.currentTarget.closest("fieldset").dataset.fieldsetName;
      value = e.currentTarget.querySelector(".label-text__name span:first-child")?.innerText || e.currentTarget.querySelector(".swatch_name")?.innerText;
    }
    if (e.type === "change") {
      optionName = e.target.closest("fieldset").dataset.fieldsetName;
      value = e.target.value;
    }

    if (optionName && value) {
      const summaryBoxText = summaryBox.querySelector(`span[data-summary-option-name="${optionName}"]`)?.nextElementSibling;
      if (summaryBoxText) {
        summaryBoxText.innerText = value;
        summaryBoxText.closest(".variant-selects__summary--option")?.classList.remove("hidden");
      }
    }
  }

  closeAndOpenNextAccordion(e) {
    const accordion = e.target.closest("collapsible-content");
    if (!accordion || accordion.classList.contains("type-swatch") || accordion.classList.contains("combined-listing-variants")) return;

    accordion.close();
    const nextAccordion = accordion.nextElementSibling;
    if (nextAccordion && nextAccordion.tagName === "COLLAPSIBLE-CONTENT") {
      nextAccordion.open();
    }
  }

  updateAccordionSelectedValue(e) {
    //find the selected option value and set it as selected
    const selectedOption = e.target.nextElementSibling.querySelector(".label-text__name span:first-child") || e.target.nextElementSibling.querySelector(".swatch_name");
    if (selectedOption) {
      const selectedLabel = selectedOption.closest("collapsible-content").querySelector(".currently-selected-variant-option");
      if (selectedLabel) {
        selectedLabel.innerText = selectedOption.dataset.value || selectedOption.innerText;
        selectedLabel.classList.remove("hidden");
      } else {
        console.error("Selected label not found to update variant selected name");
      }
      this.updateSummaryBox(e);
      if (!this.hasBundleItems) this.closeAndOpenNextAccordion(e);
    }
  }

  updateAccordionSelectedValueWhenActiveClicked(e) {
    // find the selected option value and set it as selected
    const selectedOption = e.currentTarget.querySelector(".label-text__name span:first-child") || e.currentTarget.querySelector(".swatch_name");
    if (selectedOption) {
      const selectedLabel = selectedOption.closest("collapsible-content").querySelector(".currently-selected-variant-option");
      if (selectedLabel) {
        selectedLabel.innerText = selectedOption.dataset.value || selectedOption.innerText;
        selectedLabel.classList.remove("hidden");
      } else {
        console.error("Selected label not found to update variant selected name");
      }
    }
    this.updateSummaryBox(e);
    this.closeAndOpenNextAccordion(e);
  }

  handleProductUpdate(event) {
    const input = this.getInputForEventTarget(event.target);
    const targetId = input.id;
    const targetUrl = input.dataset.productUrl || this.dataset.url;
    let refreshTP = false;
    this.currentVariant = this.getVariantData(targetId);
    const sectionId = this.dataset.originalSection || this.dataset.section;
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, false, "", "", false);
    this.removeErrorMessage();
    if (this.optionsSize > 1 || this.hasBundleItems) {
      this.updateAccordionSelectedValue(event);
    }

    let callback = () => {};
    let detailsCallback = () => {};
    if (this.dataset.url !== targetUrl) {
      this.updateURL(targetUrl);
      this.updateShareUrl(targetUrl);
      callback = this.handleSwapProduct(sectionId);
      detailsCallback = this.handleSwapProductDetails(this.pdpDetailsSection);
      refreshTP = true;
    } else if (!this.currentVariant) {
      this.setUnavailable();
      callback = (html) => {
        this.updatePickupAvailability();
        this.updateOptionValues(html);
      };
      refreshTP = true;
    } else {
      this.updateURL(targetUrl);
      this.updateVariantInput();
      this.updateShareUrl(targetUrl);
      callback = this.handleUpdateProductInfo(sectionId);
    }

    this.renderProductInfo(sectionId, targetUrl, targetId, callback, refreshTP);
    this.renderProductDetails(this.pdpDetailsSection, targetUrl, this.pdpDetailsSection, detailsCallback);
  }

  getSelectedOptionValues() {
    return Array.from(this.querySelectorAll("select, fieldset input:checked")).map((element) => element.dataset.optionValueId);
  }

  updateSelectedSwatchValue({ target }) {
    const { value, tagName } = target;

    if (tagName === "SELECT" && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target.closest(".product-form__input").querySelector("[data-selected-value] > .swatch");
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty("--swatch--background", swatchValue);
        selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
      } else {
        selectedDropdownSwatchValue.style.setProperty("--swatch--background", "unset");
        selectedDropdownSwatchValue.classList.add("swatch--unavailable");
      }

      selectedDropdownSwatchValue.style.setProperty("--swatch-focal-point", target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset");
    } else if (tagName === "INPUT" && target.type === "radio") {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector("[data-selected-value]");
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL(url) {
    if (this.dataset.updateUrl === "false") return;
    window.history.replaceState({}, "", `${url}${this.currentVariant?.id ? `?variant=${this.currentVariant.id}` : ""}`);
  }

  updateShareUrl(url) {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${url}${this.currentVariant?.id ? `?variant=${this.currentVariant.id}` : ""}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
  }

  getVariantData(inputId) {
    return JSON.parse(this.getVariantDataElement(inputId).textContent);
  }

  getVariantDataElement(inputId) {
    return this.querySelector(`script[type="application/json"][data-resource="${inputId}"]`);
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  getOldDetailsSection(sectionId) {
    return (
      document.getElementById(sectionId) || // details-section in main-product
      null
    );
  }

  getWrappingSection(sectionId) {
    return (
      this.closest(`section[data-section="${sectionId}"]`) || // main-product
      this.closest(`quick-add-modal`)?.modalContent || // quick-add
      this.closest(`#shopify-section-${sectionId}`) || // featured-product
      null
    );
  }

  handleSwapProduct(sectionId) {
    return (html) => {
      const oldContent = this.getWrappingSection(sectionId);
      if (!oldContent) {
        return;
      }

      document.getElementById(`ProductModal-${sectionId}`)?.remove();

      const response = html.querySelector(`section[data-section="${sectionId}"]`) /* main/quick-add */ || html.getElementById(`shopify-section-${sectionId}`); /* featured product*/

      this.swapProductUtility.viewTransition(oldContent, response);
    };
  }

  handleSwapProductDetails(sectionId) {
    return (html) => {
      const oldContent = this.getOldDetailsSection(sectionId);
      if (!oldContent) {
        return;
      }

      document.getElementById(`ProductDetails--${sectionId}`)?.remove();

      const response = html.querySelector(`section[data-section="${sectionId}"]`) /* main/quick-add */ || html.getElementById(`shopify-section-${sectionId}`); /* featured product*/

      this.detailsSwapUtility.viewTransition(oldContent, response);
    };
  }

  handleUpdateProductInfo(sectionId) {
    return (html) => {
      this.updatePickupAvailability();
      this.updateMedia(html);
      const saleBadgeDestination = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"] .sale-badge`);
      const saleBadgeSource = html.querySelector(`[id^="MediaGallery-${sectionId}"] .sale-badge`);

      const priceDestination = document.getElementById(`price-${this.dataset.section}`);
      const priceStickyAtcDestination = document.querySelector("sticky-atc .sticky-atc-price");
      const priceSource = html.getElementById(`price-${sectionId}`);

      const skuSource = html.getElementById(`Sku-${sectionId}`);
      const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
      const inventorySource = html.getElementById(`Inventory-${sectionId}`);
      const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
      const pdpLeadTextSource = html.getElementById(`Lead-Text-${this.dataset.section}`);
      const pdpLeadTextDestination = document.getElementById(`Lead-Text-${sectionId}`);
      const pdpDeliveryInformationSource = html.getElementById(`Delivery-Information-${sectionId}`);
      const pdpDeliveryInformationDestination = document.getElementById(`Delivery-Information-${this.dataset.section}`);
      const pdpBISButtonSource = html.getElementById(`klayvio-modal-trigger-${sectionId}`);
      const pdpBISButtonDestination = document.getElementById(`klayvio-modal-trigger-${this.dataset.section}`);
      const sticktAtcBISButtonDestination = document.querySelector("sticky-atc klayvio-modal-trigger");
      const pdpPreorderFormInputSource = html.getElementById(`preorder-message-${sectionId}`);
      const pdpPreorderFormInputDestination = document.getElementById(`preorder-message-${this.dataset.section}`);

      const volumePricingSource = html.getElementById(`Volume-${sectionId}`);

      const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
      const pricePerItemSource = html.getElementById(`Price-Per-Item-${sectionId}`);

      const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
      const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
      const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

      if (pdpPreorderFormInputSource && pdpPreorderFormInputDestination) {
        pdpPreorderFormInputDestination.replaceWith(pdpPreorderFormInputSource.cloneNode(true));
      }

      if (volumeNote) volumeNote.classList.remove("hidden");
      if (volumePricingDestination) volumePricingDestination.classList.remove("hidden");
      if (qtyRules) qtyRules.classList.remove("hidden");
      if (saleBadgeSource && saleBadgeDestination) {
        saleBadgeDestination.innerHTML = saleBadgeSource.innerHTML;
        saleBadgeDestination.classList.toggle("hidden", saleBadgeSource.classList.contains("hidden"));
      }
      if (priceSource && priceDestination) priceDestination.innerHTML = priceSource.innerHTML;

      if (priceStickyAtcDestination && priceSource) {
        priceSource.querySelector(".sticky-atc-price-save")?.classList.remove("hidden");
        priceSource.querySelector(".badge.price__badge-save")?.classList.add("hidden");
        priceSource.querySelector(".pdp-stock-msg")?.classList.add("hidden");
        priceStickyAtcDestination.innerHTML = priceSource.innerHTML;
      }

      if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
      if (skuSource && skuDestination) {
        skuDestination.innerHTML = skuSource.innerHTML;
        skuDestination.classList.toggle("hidden", skuSource.classList.contains("hidden"));
      }
      if (volumePricingSource && volumePricingDestination) {
        volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
      }
      if (pricePerItemSource && pricePerItemDestination) {
        pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
        pricePerItemDestination.classList.toggle("hidden", pricePerItemSource.classList.contains("hidden"));
      }

      const price = document.getElementById(`price-${this.dataset.section}`);
      if (price) price.classList.remove("hidden");

      if (inventoryDestination) inventoryDestination.classList.toggle("hidden", inventorySource.innerText === "");

      if (pdpLeadTextSource && pdpLeadTextDestination) {
        pdpLeadTextDestination.innerHTML = pdpLeadTextSource.innerHTML;
        if (pdpLeadTextSource.classList.contains("hidden")) {
          pdpLeadTextDestination.classList.add("hidden");
        } else {
          pdpLeadTextDestination.classList.remove("hidden");
        }
      }
      if (pdpBISButtonSource && pdpBISButtonDestination) {
        pdpBISButtonDestination.replaceWith(pdpBISButtonSource.cloneNode(true));
        if (pdpBISButtonSource.classList.contains("hidden")) {
          pdpBISButtonDestination.classList.add("hidden");
        } else {
          pdpBISButtonDestination.classList.remove("hidden");
        }
      }

      if (sticktAtcBISButtonDestination && pdpBISButtonSource) {
        if (pdpBISButtonSource.classList.contains("hidden")) {
          sticktAtcBISButtonDestination.classList.add("hidden");
        } else {
          sticktAtcBISButtonDestination.classList.remove("hidden");
          sticktAtcBISButtonDestination.replaceWith(pdpBISButtonSource.cloneNode(true));
        }
      }

      if (pdpDeliveryInformationSource && pdpDeliveryInformationDestination) {
        pdpDeliveryInformationDestination.innerHTML = pdpDeliveryInformationSource.innerHTML;
      }

      const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
      const addButtonIsDisabled = addButtonUpdated ? addButtonUpdated?.hasAttribute("disabled") : true;
      const addButtonIsPreorder = addButtonUpdated?.hasAttribute("data-is-preorder");
      this.toggleAddButton(addButtonIsDisabled, addButtonIsPreorder, window.variantStrings.soldOut, window.variantStrings.addToCartPreorder);

      this.updateOptionValues(html);

      publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          sectionId,
          html,
          variant: this.currentVariant,
        },
      });
    };
  }

  updateOptionValues(html) {
    const variantSelects = html.querySelector("variant-selects");
    const allNewFieldsets = variantSelects.querySelectorAll("fieldset");
    this.variantSelectFieldsets = this.querySelectorAll("fieldset");
    this.variantSelectFieldsets.forEach((fieldset) => {
      allNewFieldsets.forEach((newFieldset) => {
        if (fieldset.dataset.fieldsetId === newFieldset.dataset.fieldsetId) {
          fieldset.innerHTML = newFieldset.innerHTML;
        }
      });
    });

    // update fixed bundle items
    const fixedBundleItems = this.querySelector(".variant-fixed-bundle-items");
    const newFixedBundleItems = html.querySelector(".variant-fixed-bundle-items");

    if (fixedBundleItems && newFixedBundleItems) {
      fixedBundleItems.replaceWith(newFixedBundleItems.cloneNode(true));

      const bundlesSummaryBox = this.querySelector(".variant-selects__summary-box");
      const newBundlesSummaryBox = html.querySelector(".variant-selects__summary-box");
      if (bundlesSummaryBox && newBundlesSummaryBox) {
        bundlesSummaryBox.innerHTML = newBundlesSummaryBox.innerHTML;
      }
    }

    this.attachActiveVariantEvent();

    // if (variantSelects) this.innerHTML = variantSelects.innerHTML;
  }

  renderProductInfo(sectionId, url, targetId, callback, refreshTP = false) {
    const params = this.currentVariant ? `variant=${this.currentVariant?.id}` : `option_values=${this.getSelectedOptionValues().join(",")}`;

    this.abortController?.abort();
    this.abortController = new AbortController();

    fetch(`${url}?section_id=${sectionId}&${params}`, {
      signal: this.abortController.signal,
    })
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        callback(html);
      })
      .then(() => {
        // set focus to last clicked option value
        document.getElementById(targetId).focus();
        if (refreshTP) {
          this.refreshTrustPilotWidget();
        }
      });
  }

  renderProductDetails(sectionId, url, targetId, callback) {
    const params = this.currentVariant ? `variant=${this.currentVariant?.id}` : `option_values=${this.getSelectedOptionValues().join(",")}`;

    if (!sectionId) return;

    this.abortDetailsController?.abort();
    this.abortDetailsController = new AbortController();

    fetch(`${url}?section_id=${sectionId}&${params}`, {
      signal: this.abortDetailsController.signal,
    })
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        callback(html);
      });
  }

  toggleAddButton(disable = true, preorder = false, text, textPreorder, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const stickyAddButton = document.querySelector("[data-sticky-atc-btn]");
    const stickyAddButtonText = document.querySelector("[data-sticky-atc-btn] > span");

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      addButton.removeAttribute("data-is-preorder");
      if (text) addButtonText.textContent = text;
    } else if (preorder) {
      addButton.setAttribute("data-is-preorder", "true");
      addButton.removeAttribute("disabled");
      if (textPreorder) {
        addButtonText.textContent = textPreorder;
      }
    } else {
      addButton.removeAttribute("disabled");
      addButton.removeAttribute("data-is-preorder");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (stickyAddButton) {
      if (disable) {
        stickyAddButton.setAttribute("disabled", "disabled");
        stickyAddButton.removeAttribute("data-is-preorder");
        if (text) stickyAddButtonText.textContent = text;
      } else if (preorder) {
        stickyAddButton.setAttribute("data-is-preorder", "true");
        stickyAddButton.removeAttribute("disabled");
        if (textPreorder) {
          stickyAddButtonText.textContent = textPreorder;
        }
      } else {
        stickyAddButton.removeAttribute("disabled");
        stickyAddButton.removeAttribute("data-is-preorder");
        stickyAddButtonText.textContent = window.variantStrings.addToCart;
      }
    }
  }

  setUnavailable() {
    this.toggleAddButton(true, "", true);
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("hidden");
    if (inventory) inventory.classList.add("hidden");
    if (sku) sku.classList.add("hidden");
    if (pricePerItem) pricePerItem.classList.add("hidden");
    if (volumeNote) volumeNote.classList.add("hidden");
    if (volumeTable) volumeTable.classList.add("hidden");
    if (qtyRules) qtyRules.classList.add("hidden");
  }

  getInputSelector() {
    return 'variant-selects fieldset input[type="radio"], variant-selects select option';
  }
}

customElements.define("variant-selects", VariantSelects);

class ReadMore extends HTMLElement {
  constructor() {
    super();
    this.isExpanded = this.getAttribute("aria-expanded") === "true";
    const toggleButtons = this.querySelectorAll(".js-read-more-toggle");
    toggleButtons.forEach((button) => button.addEventListener("click", this.toggle.bind(this)));
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
    this.setAttribute("aria-expanded", this.isExpanded);
  }
}

window.customElements.define("read-more", ReadMore);

class ClassToggle extends HTMLElement {
  constructor() {
    super();
    this.onclick = () => {
      document.querySelector(this.dataset.target).classList.toggle(this.dataset.class);
      this.classList.toggle("active");
    };
  }
}

window.customElements.define("class-toggle", ClassToggle);
